import { useContext } from 'react';

import { RulesEngineContext } from '../contexts/RulesEngineContext';
import type { RulesEngineContextType } from '../types/rulesEngineContextType';

// Public surface for screens: onboarding data + domain actions. Forward step
// navigation (`goToNextStep`) is intentionally omitted — it's surfaced via
// `useOnboardingSteps` so step movement has a single home (`goBack` +
// `stepHistory` already live in OnboardingStepsContext, not here). The full
// context including `goToNextStep` is still reachable via
// `useContext(RulesEngineContext)`, which is how `useOnboardingSteps` reads it.
export type UseRulesEngine = Omit<RulesEngineContextType, 'goToNextStep'>;

export const useRulesEngine = (): UseRulesEngine => {
  const context = useContext(RulesEngineContext);
  if (!context) {
    throw new Error('useRulesEngine must be used within a RulesEngineProvider');
  }
  return context;
};
